import { useTranslation } from 'react-i18next'

export function jsonActionsSecurityGroups (handleModal, data, deleted, { actionLockDevices, actionUnlockDevices }) {
  // Despliegue de boton de acciones de contenido
  const { t } = useTranslation('dashboardGroup')
  const result = []

  if (actionLockDevices) {
    result.push({
      label: t('speedDialMenu.item1'),
      icon: 'pi pi-lock-open',
      command: () => {
        handleModal('desbloquear', true)
      }
    })
  }

  if (actionUnlockDevices) {
    result.push({
      label: t('speedDialMenu.item2'),
      icon: 'pi pi-lock',
      command: () => {
        handleModal('bloquear', true)
      }
    })
  }
  // {
  //     label: "Activar Dispositivos",
  //     icon: "pi pi-check-circle",
  //     command: () => {
  //         //deleted("activar");
  //     }
  // },
  // {
  //     label: "Desactivar Dispositivos",
  //     icon: "pi pi-times-circle",
  //     command: () => {
  //         //deleted("desactivar");
  //     }
  // }
  return result
}

export function jsonActionsSystemGroups (rebootShutdownRestart, id, { actionShutdown, actionReboot }) {
  // Despliegue de boton de acciones de sistema
  const { t } = useTranslation('dashboardGroup')
  const result = []

  if (actionShutdown) {
    result.push({
      label: t('speedDialMenu.item3'),
      icon: 'pi pi-power-off',
      command: () => {
        rebootShutdownRestart('shutdown', t('speedDialMenu.item3'), 'groups', id)
      }
    })
  }
  if (actionReboot) {
    result.push({
      label: t('speedDialMenu.item4'),
      icon: 'pi pi-replay',
      command: () => {
        rebootShutdownRestart('reboot', t('speedDialMenu.item4'), 'groups', id)
      }
    })
  }

  return result
}

export function jsonApplicationsGroups (idGroup, { actionInstallApplication, actionUninstallApplication }, handleModal) {
  // Despliegue de boton de acciones de aplicaciones
  const { t } = useTranslation('dashboardGroup')
  const result = []

  if (actionUninstallApplication) {
    result.push({
      label: t('speedDialMenu.item5'),
      icon: 'pi pi-upload',
      command: () => {
        handleModal('uninstallApplications', true)
      }
    })
  }

  if (actionInstallApplication) {
    result.push({
      label: t('speedDialMenu.item6'),
      icon: 'pi pi-download',
      command: () => {
        handleModal('installApplications', true)
      }
    })
  }

  return result
}
